import { render, staticRenderFns } from "./BaseSelectModalBox.vue?vue&type=template&id=aa51966e&scoped=true"
import script from "./BaseSelectModalBox.vue?vue&type=script&lang=js"
export * from "./BaseSelectModalBox.vue?vue&type=script&lang=js"
import style0 from "./BaseSelectModalBox.vue?vue&type=style&index=0&id=aa51966e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa51966e",
  null
  
)

export default component.exports